// eslint-disable-next-line no-use-before-define
import React, { Suspense, useState } from 'react';
import { useQuery } from 'react-query';

import { Badge, Card, Space } from 'antd';
import styles from './index.less';

import DF from 'DisplayFramework';

import MyChecksTable from '../../pages/Landing/components/MyChecksTable';
import HeaderDropdown from 'components/HeaderDropdown';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { GetListProcTaskCheck } from 'services/workflow';
import IChecks from 'icons/IChecks';

const ChecksLink = () => {
  const [countCheck, setCountCheck] = useState(0);

  const { data } = useQuery(
    'GetListProcTaskCheck',
    () =>
      GetListProcTaskCheck().then((res) => {
        setCountCheck(res.list?.length??0);
        return res.list;
      }),
    { refetchOnMount: true, refetchInterval: 60000 }
  );

  const menu = (
    <Suspense fallback="Loading">
      <Card style={{ width: '800px' }}>
        <MyChecksTable
          height={500}
          title={<GetLabel label="checks" />}
          isFromLink
          checkTable={data}
        />
      </Card>
    </Suspense>
  );

  return (
    <DF.Provider pagcode="welcome">
      <HeaderDropdown overlay={menu} zIndex={7}>
      <span className={`${styles.action}`}>
        <Space size={24}>
          {/* <IChecks color="#eb2f96" /> */}
          <IChecks color="black" />
          <Badge count={countCheck} style={{ backgroundColor: 'purple' }}>
            <GetLabel label="checks" Inspectstyle={{ marginBottom: '25px' }}/>
          </Badge>
        </Space>
        </span>
      </HeaderDropdown>
    </DF.Provider>
  );
};

export default ChecksLink;
